// import bootstrap
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

import Container from "./container/Container.vue";
import TopContainer from "./container/TopContainer.vue";
import FooterContainer from "./container/FooterContainer.vue";
import TextInput from "./form/TextInput.vue";
import Select from "./form/Select";
import ButtonPrimary from "./button/ButtonPrimary";
import ButtonSecondary from "./button/ButtonSecondary";
import ButtonWhite from "./button/ButtonWhite";
import PageProgressBar from "./progress-bar/PageProgressBar";
import TextPrimary from "./text/TextPrimary";
import TextDark from "./text/TextDark";
import TextLight from "./text/TextLight.vue";
import Text from "./text/Text";
import Card from "./card/Card.vue";

const Components = {
  Container,
  TopContainer,
  FooterContainer,
  TextInput,
  Select,
  ButtonPrimary,
  ButtonSecondary,
  ButtonWhite,
  PageProgressBar,
  TextPrimary,
  TextDark,
  TextLight,
  Text,
  Card,
};

export default Components;
